// src/pages/ProductMonAppliClubLight/DiaporamaLight.jsx
import React, { useEffect, useRef, useState } from "react";
import {
  FaArrowRight,
  FaArrowLeft,
  FaPlay,
  FaPause,
} from "react-icons/fa";

const cx = (...c) => c.filter(Boolean).join(" ");

const images = [
  { src: "/images/diapo2/001.webp", alt: "Accueil", caption: "Accueil" },
  { src: "/images/diapo2/002.webp", alt: "Accueil", caption: "Accueil" },
  { src: "/images/diapo2/003.webp", alt: "Accueil", caption: "Accueil" },
  { src: "/images/diapo2/004.webp", alt: "Le Club", caption: "Le Club" },
  {
    src: "/images/diapo2/005.webp",
    alt: "Groupes, Horaires & Tarifs",
    caption: "Groupes, Horaires & Tarifs",
  },
  {
    src: "/images/diapo2/006.webp",
    alt: "Inscription des adhérents",
    caption: "Inscription des adhérents",
  },
  {
    src: "/images/diapo2/007.webp",
    alt: "Tableau de bord administrateur",
    caption: "Tableau de bord administrateur",
  },
  {
    src: "/images/diapo2/008.webp",
    alt: "Listing Adhérents administrateur",
    caption: "Listing Adhérents",
  },
  {
    src: "/images/diapo2/009.webp",
    alt: "Gestion des équipes administrateur",
    caption: "Gestion des équipes",
  },
  {
    src: "/images/diapo2/010.webp",
    alt: "Paramètres Club administrateur",
    caption: "Paramètres du club",
  },
];

const DiaporamaLight = () => {
  const [current, setCurrent] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const touch = useRef({ x: 0, y: 0, active: false });

  const next = () => setCurrent((p) => (p + 1) % images.length);
  const prev = () => setCurrent((p) => (p === 0 ? images.length - 1 : p - 1));

  useEffect(() => {
    const reduceMotion =
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (reduceMotion || !autoPlay) return;

    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [autoPlay]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const onTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;
    touch.current = { x: t.clientX, y: t.clientY, active: true };
  };

  const onTouchEnd = (e) => {
    if (!touch.current.active) return;
    const t = e.changedTouches?.[0];
    if (!t) return;

    const dx = t.clientX - touch.current.x;
    const dy = t.clientY - touch.current.y;
    touch.current.active = false;

    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      dx < 0 ? next() : prev();
    }
  };

  const item = images[current];

  return (
    <section className="bg-slate-50 py-16 sm:py-20 dark:bg-slate-900/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="text-sm font-semibold uppercase tracking-[0.18em] text-sky-500">
            Aperçus
          </div>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-5xl dark:text-white">
            Quelques écrans pour découvrir l’expérience Light
          </h2>
          <p className="mt-4 text-base leading-8 text-slate-600 sm:text-lg dark:text-slate-300">
            Une sélection de pages pour visualiser le site public et
            l’administration.
          </p>
        </div>

        <div className="mt-10 rounded-[32px] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-900 sm:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="text-lg font-semibold text-slate-900 dark:text-white">
                {item.caption}
              </div>
              <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {current + 1} / {images.length}
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                className="grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                aria-label="Précédent"
              >
                <FaArrowLeft />
              </button>

              <button
                onClick={() => setAutoPlay((v) => !v)}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
              >
                {autoPlay ? <FaPause /> : <FaPlay />}
                {autoPlay ? "Pause" : "Auto"}
              </button>

              <button
                onClick={next}
                className="grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                aria-label="Suivant"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>

          <div
            className="mt-5 overflow-hidden rounded-[28px] border border-slate-200 bg-slate-50 dark:border-white/10 dark:bg-slate-950"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <img
              src={item.src}
              alt={item.alt}
              className="w-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="mt-5">
            <div className="mb-3 text-sm font-semibold text-slate-900 dark:text-white">
              Accès direct
            </div>

            <div className="flex gap-3 overflow-x-auto pb-2">
              {images.map((img, i) => (
                <button
                  key={img.src}
                  onClick={() => setCurrent(i)}
                  className={cx(
                    "shrink-0 overflow-hidden rounded-2xl border transition",
                    i === current
                      ? "border-sky-500 ring-2 ring-sky-400/30"
                      : "border-slate-200 hover:border-sky-300 dark:border-white/10 dark:hover:border-sky-500/40"
                  )}
                  aria-label={`Aller à ${img.caption}`}
                  title={img.caption}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="h-20 w-32 object-cover"
                    loading="lazy"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiaporamaLight;